'use client';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import VehicleClassifierForm from './VehicleClassifierForm';
import Button from '../Button';
import Icon from '../Icon';
import { IoCarSport } from 'react-icons/io5';

export default function VehicleClassifierPopup({ buttonVariant }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      {/* Trigger Button */}
      <button
        as="div"
        type="button"
        onClick={openModal}
        className="bg-primary border-primary text-primary-foreground inline-flex items-center justify-center rounded px-4 py-2.5 text-sm font-semibold uppercase shadow transition hover:shadow-md hover:brightness-80"
      >
        <Icon icon={IoCarSport} className="mr-2" />
        Classify Your Vehicle
      </button>

      {/* Portal for the Modal Popup */}
      {isOpen &&
        createPortal(
          <div className="fixed inset-0 z-1000 flex items-center justify-center">
            {/* Overlay */}
            <div
              className="bg-secondary absolute inset-0 opacity-75"
              onClick={closeModal}
            />

            {/* Modal Container */}
            <div className="tablet:mx-8 relative mx-4 w-full max-w-4xl rounded-lg bg-white shadow-xl">
              {/* Close Button */}
              <button
                onClick={closeModal}
                className="absolute right-2 p-2 text-3xl font-bold text-gray-600 hover:text-gray-800"
              >
                &times;
              </button>

              {/* Vehicle Classifier Form */}
              <VehicleClassifierForm />
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
